export function BrandMark() {
  return (
    <svg
      className="hp-print-mark"
      viewBox="0 0 40 40"
      width="40"
      height="40"
      aria-hidden="true"
      focusable="false"
    >
      <path fill="#173F3B" d="M3 3h8a8 8 0 0 1 8 8v8h-8a8 8 0 0 1-8-8Z" />
      <path fill="#C34B45" d="M29 3h8v8a8 8 0 0 1-8 8h-8v-8a8 8 0 0 1 8-8Z" />
      <path fill="#318677" d="M11 21h8v8a8 8 0 0 1-8 8H3v-8a8 8 0 0 1 8-8Z" />
      <path fill="#F3C75B" d="M21 21h8a8 8 0 0 1 8 8v8h-8a8 8 0 0 1-8-8Z" />
    </svg>
  );
}
